import { hubletApi } from 'hub-http/middlewares/core';
import { apiClientWithMiddleware } from '../../utils/API';
import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { feedbackModalConfig } from '../../components/FeedbackModal/config';
const postRatingUrl = 'feedback/public/v1/submit/csat';
const postFeedbackUrl = `feedback/public/v1/submission-follow-up/csat`;
const getSurveyUrl = (email, portalId, feedbackSurveyType) => {
  const {
    type,
    id,
    portal
  } = feedbackModalConfig[feedbackSurveyType].survey;
  return `feedback/v1/survey-config/${type}/${id}?email=${window.encodeURIComponent(email)}}&portalId=${portalId}&targetPortalId=${portal}`;
};
export const getSurveyContactId = ({
  email,
  portalId,
  feedbackSurveyType
}) => {
  return apiClientWithMiddleware().get(getSurveyUrl(email, portalId, feedbackSurveyType), {
    ignoreRedirect: true
  }).then(({
    webRespondent
  }) => {
    return webRespondent.contactId;
  });
};
const postRating = ({
  value,
  contactId,
  feedbackSurveyType
}) => {
  const {
    id,
    portal
  } = feedbackModalConfig[feedbackSurveyType].survey;
  return noAuthApiClient.post(postRatingUrl, {
    api: hubletApi('feedback', 'hubapi'),
    headers: {
      'X-HS-Referer': window.location.href
    },
    data: {
      channel: 'WEB',
      contactId,
      portalId: portal,
      surveyChannel: 'WEB',
      surveyId: id,
      value,
      webAnalytics: {
        pageUrl: window.location.href,
        userAgent: window.navigator.userAgent
      }
    },
    withCredentials: false
  });
};
export const postRatingAndFeedback = ({
  followUp,
  rating,
  contactId,
  feedbackSurveyType
}) => {
  const {
    type,
    id,
    portal
  } = feedbackModalConfig[feedbackSurveyType].survey;
  return postRating({
    value: rating,
    contactId,
    feedbackSurveyType
  }).then(({
    submissionId
  }) => {
    return noAuthApiClient.post(postFeedbackUrl, {
      api: hubletApi('feedback', 'hubapi'),
      data: {
        followUp,
        portalId: portal,
        rating,
        surveyId: id,
        surveyType: type,
        submissionId
      },
      headers: {
        'X-HS-Referer': window.location.href
      },
      withCredentials: false
    });
  });
};